<div class="page-container logout-page">
    <div class="logout-container">
      <h5 class="my-4">You've Signed Out</h5>
      <p class="text-center">You are now logged out from Deloitte Tax.</p>
      <button class="btn btn-link" (click)="login()">Login again</button>
    </div>
  </div>
  